import { assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestDiffusionModelsUDRent extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_DIFFUSION_MODEL_UD_RENT;

  /*
   * DB FIELDS
   */

  workspace_id!: string;
  diffusion_model_id!: string;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_not_empty(this.workspace_id);
    assert_string_not_empty(this.diffusion_model_id);
  }
}
